export const WS_CONDITION_PRELOADED = 'preloaded';
export const WS_CONDITION_CHANGING = 'changing';
export const WS_CONDITION_HOVER = 'hover';
export const WS_CONDITION_HOVER_CONTAINER = 'hover-container';
export const WS_CONDITION_RECORD = 'record';
export const WS_CONDITION_DELETING = 'deleting';
